import React, { Component } from 'react';
import MapContainer from '../GoogleMap/MapContainer';
import TopNav from '../../../components/TopNav';
import AddressParser from './src/AddressParser';
import PlacesAutocomplete from 'react-places-autocomplete';
import {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
} from 'react-places-autocomplete';
import Navigator from '../Navigator/Navigator';
import OrderHandler from '../Handler/OrderHandler';
import { TableSessionType } from '../../Common/Enum/TableSessionType';
import DeliveryDetail from '../../../Model/DeliveryDetail';
import DeliveryPriceCalculator from './helper/DeliveryPriceCalculator';

function DeliveryInfo({label, value, description = ""}) {
    return <div>
        <div style={{fontSize:"80%"}}>{label}</div>
        <div style={{fontSize:"150%"}}><strong>{value}</strong></div>
        <div style={{fontSize:"80%", display: description == ""? "none":"inherit"}}><strong>{description}</strong></div>
    </div>
}

const DEFAULT_DELIVERY_PROCESSING_FEE = DeliveryPriceCalculator.DEFAULT_DELIVERY_PROCESSING_FEE
const DEFAULT_DELIVERY_COST_MERCHANT_COVER = DeliveryPriceCalculator.DEFAULT_DELIVERY_COST_MERCHANT_COVER

class SelectDeliveryLocation extends Component {
    constructor(props) {
        super(props);

        // Set to true if location permission granted. Then will zoom to user
        // current location when amp is ready
        this.isNeedZoomToCurrentLocation = false

        // Set to true if location permission denied. Then will drop pin to
        // whatever location that is on map now
        this.isLocationPermissionDenied = false
        this.state = {
            initialPosition: null,
            streetNumber: "",
            destinationMarker: {
                position: null,
                icon: {
                    url:"/images/map/food_delivery.png",
                    size: [60, 60],
                }
            },
            distanceData: {
                distance_text: '--',
                duration_text : '--',
                price_text: '--',
            },
            merchantCoordinate: {lat: 3.005644, lng: 101.398777},
            isShowGoToCurrentLocationButton: false,
            isMapReady: false,
            too_far: false,
            free_delivery: false,
            isShowHint: true,
        }
        this.mapRef = React.createRef()

        // First N times will be triggered by system instead of user action, so 
        // we skip the hint first
        this.geoCodeCount = 0
    }

    destinationMarkerChangeIcon = (type, duration) => {
        // this.usingIcon1 = !this.usingIcon1
        if (type == "hint") {
            this.mapRef.current && this.mapRef.current.setDestinationIconImage({
                url:"/images/map/food_delivery_arrow_1.png",
                label: "2. " + (lang.move_pin_to_destination || "Move pin to destination"),
                size: [80, 80],
            })
            setTimeout(() => {
                // Revert back to original icon
                this.destinationMarkerChangeIcon()
            }, duration)
        }
        else {
            this.mapRef.current && this.mapRef.current.setDestinationIconImage({
                url:"/images/map/food_delivery.png",
                size: [60, 60],
                label: null,
            })
        }
    }

    getMerchantCoordinate = () => {
        let coordinateStr = this.props.app.getMerchantSettingValue('merchant_outlet_coordinate')
        if (coordinateStr) {
            let components = coordinateStr.split(",")
            return {
                lat: parseFloat(components[0]),
                lng: parseFloat(components[1]),
            }
        }
    }

    setCurrentPosition = (position) => {
        let currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        }
        this.setState({
            currentLocation: {...currentLocation},
            destinationMarker: {
                ...this.state.destinationMarker,
                position: {...currentLocation},
            },
            isShowGoToCurrentLocationButton: true,
        }, () => {
            // Done get user location, zoom to it now
            this.isNeedZoomToCurrentLocation = true
            this.handleZoomToCurrentLocation()
        })
    }

    componentDidMount() {
        const deliveryDetail = OrderHandler.getDeliveryDetail()
        let currentLocation = deliveryDetail && OrderHandler.getDeliveryCoordinate()
        if (currentLocation) {
            this.setState({
                currentLocation: {...currentLocation},
                destinationMarker: {
                    ...this.state.destinationMarker,
                    position: {...currentLocation},
                },
                isShowGoToCurrentLocationButton: true,
            }, () => {
                // Done get user location, zoom to it now
                this.isNeedZoomToCurrentLocation = true
                this.handleZoomToCurrentLocation()
            })
        }
        else if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.setCurrentPosition(position)
            }, (error) => {
                if (error.code == error.PERMISSION_DENIED) {
                    // No permission, just set the PIN to center of map
                    this.isLocationPermissionDenied = true
                    this.handleLocationPermissionDenied()
                } else {
                    console.log(error)
                }
            });
        } else {
            alert("Geolocation is not supported by this browser.")
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.destinationMarker.position != this.state.destinationMarker.position) {
            this.setPinToCustomPosition(this.state.destinationMarker.position)
        }
    }
    componentWillUnmount() {

    }

    handleZoomToCurrentLocation = () => {
        this.state.isMapReady && this.isNeedZoomToCurrentLocation && this.setPinToCurrentLocationClicked()
    }
    handleLocationPermissionDenied = () => {
        this.state.isMapReady && this.isLocationPermissionDenied && this.setPinToMapClicked()
    }
    mapReady = () => {
        this.setState({
            isMapReady: true
        }, () => {
            this.handleLocationPermissionDenied()
            this.handleZoomToCurrentLocation()
        })
    }

    zoomToDestination = () => {
        this.mapRef.current && this.mapRef.current.zoomToDestination()
    }
    setPinToMapClicked = () => {
        let mapCenter = this.mapRef.current && this.mapRef.current.getCenter()
        if (mapCenter) {
            this.setPinToCustomPosition(mapCenter.toJSON())
        }
    }
    setPinToCurrentLocationClicked = () => {
        if (this.state.currentLocation) {
            this.setPinToCustomPosition(this.state.currentLocation)
            this.zoomToDestination()
        }
    }
    setPinToCustomPosition = (position) => {
        let mapRef = this.mapRef.current
        if (mapRef) {
            mapRef.setDestinationPosition(position)
        }
    }

    onAutoCompletePlaceSelected = (position, geocodeResult) => {
        this.destinationMarkerChangeIcon("hint", 6000)
        this.setPinToCustomPosition(position, true)
        this.onGeocodeResult(geocodeResult)
        setTimeout(this.zoomToDestination, 200)
    }

    calculateDistance = () => {
        let coordinate = this.mapRef.current.getDestinationCoordinate()
        let merchantCoordinate = this.getMerchantCoordinate() // this.state.merchantCoordinate
        if(merchantCoordinate == undefined){
            alert(lang.outlet_no_coordinate);
            return;
        }

        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
        {
            origins: [merchantCoordinate],  // , "Aeon Bukit Tinggi"
            destinations: [coordinate], // , "GM Klang"
            travelMode: 'DRIVING',
        }, (response, status) => {
            if (status == 'OK') {
                let origins = response.originAddresses;
                let destinations = response.destinationAddresses;

                for (let i = 0; i < origins.length; i++) {
                    let results = response.rows[i].elements;
                    for (let j = 0; j < results.length; j++) {
                        const element = results[j];
                        let data = {
                            // element: results[j],
                            distance_text: element.distance.text,
                            duration_text: element.duration.text,
                            distance: element.distance.value,
                            duration: element.duration.value,
                            from: origins[i],
                            to: destinations[j],
                        }
                        this.setState({
                            distanceData: this.calculatePrice(data)
                        }, () => {
                            $(document).trigger('SelectDeliveryLocation.doneCalculateDeliveryPrice')
                        })
                        return
                    }
                }
              }
        });
    }

    getDeliverySettingValue = (key, defaultValue) => {
        let value = this.props.app.getMerchantSettingValue(key)
        if (value == null || value == '') {
            return defaultValue
        }
        return parseFloat(value) || 0   // Return 0 if unable to parse value
    }
    getDeliveryRates = () => {
        if (this.props.app.getMerchantSettingValue('is_allow_merchant_use_own_delivery_team')) {
            let deliveryRates = this.props.app.getMerchantSettingValue('delivery_rates')
            if (deliveryRates) {
                return JSON.parse(deliveryRates)
            }
        }
        return []
    }
    calculatePrice = (distanceData) => {
        let distance = 0
        let duration = 0
        let price = 0
        let basePrice = 0
        let merchantCoverFee = DEFAULT_DELIVERY_COST_MERCHANT_COVER
        let processingFee = DEFAULT_DELIVERY_PROCESSING_FEE

        let distance_text = '--'
        let duration_text  = '--'
        let price_text = '--'

        if (distanceData.distance) {
            let km = (distanceData.distance || 0) / 1000

            let maxKm = 10
            let minKm = 5
            let minKmPrice = 5
            let perKmPrice = 1

            minKm = this.getDeliverySettingValue('delivery_minimum_charge_distance', minKm)
            minKmPrice = this.getDeliverySettingValue('delivery_minimum_charge', minKmPrice)
            perKmPrice = this.getDeliverySettingValue('delivery_extra_charge_per_km', perKmPrice)
            maxKm = this.getDeliverySettingValue('delivery_maximum_distance', maxKm)
            merchantCoverFee = this.getDeliverySettingValue('delivery_cost_merchant_cover', merchantCoverFee)
            processingFee = this.getDeliverySettingValue('delivery_processing_fee', processingFee)

            let deliveryRate = this.getDeliveryRates().find(dr => {
                // Return the first item that has distance less than measure distance
                // Say distance = 12
                // 0 - 5
                // 5 - 10
                // 10 - N    <--- find this, if N > 12
                // N - null  <--- Or this, if N < 12
                return dr.till > km || dr.till == null
            })

            // Override some of the delivery_* settings if has define deliveryRates array
            if (deliveryRate) {
                minKm = deliveryRate.from
                minKmPrice = deliveryRate.base_price
                perKmPrice = deliveryRate.rate_per_km
            }

            let baseCharge = minKmPrice
            let extraKm = Math.round(km - minKm).toFixed(0)
            let extraKmPrice = extraKm > 0 ? extraKm * perKmPrice : 0

            // RM 1 Profit
            basePrice = baseCharge + extraKmPrice
            price = basePrice + processingFee - merchantCoverFee
            price = price < 0 ? 0 : price

            price_text = km >= maxKm? lang.too_far : price > 0 ? "≈ "+( this.props.currencyName ?  this.props.currencyName : "RM" )+" " + (price).toFixed(2) : lang.free_delivery// + " - " + priceMax.toFixed(0)
            distance = (Math.round(km)).toFixed(0)

            if (deliveryRate && deliveryRate.from == 0) {
                distance_text = "<" + deliveryRate.till + " km"
            }
            else if(km < minKm){
                distance_text = "<" + minKm + " km"
            }
            else{
                distance_text = distance + " km"
            }
            duration = Math.ceil(distanceData.duration / 60)
            duration_text = Math.ceil(distanceData.duration / 60) + " minutes"

            let too_far = km >= maxKm? true : false
            let free_delivery = price > 0 ? false : true;
            this.setState({
                too_far: too_far,
                free_delivery: free_delivery,
            })
        }

        return {
            price_text, price, distance, distance_text, duration, duration_text, basePrice, merchantCoverFee, processingFee
        }
    }
    onGeocodeResult = (results, source) => {
        let addressParser = new AddressParser(results)

        // House number
        let streetNumber = addressParser.getStreetNumber() || ""
        // Street
        let route = addressParser.getRoute() || ""
        // Taman (One level below City, can have sublocalityLevel1 - sublocalityLevel5)
        let sublocality = addressParser.getSublocality() || ""
        // City
        let locality = addressParser.getLocality() || ""
        // State (One level below Country)
        let administrativeAreaLevel_1 = addressParser.getAdministrativeAreaLevel_1() || ""
        let postalCode = addressParser.getPostalCode() || ""

        this.setState({
            streetNumber, route, postalCode, administrativeAreaLevel_1, locality, sublocality
        })

        this.calculateDistance()

        if (source == 'marker') {
            if (this.geoCodeCount < 2) {
                this.geoCodeCount++
                return
            }
            // Market dragged, hint user to fill in street address
            this.showFillStreetNumberHint()
        }
    }

    getFillInStreetNumberHint() {
        return "3. " + lang.please_fill_in_and_confirm.replace("%data%", lang.street_number_placeholder)
    }

    showFillStreetNumberHint() {
        this.setState({
            isNeedFillSteetNumber: true,
        }, () => {
            if (this.isNeedFillSteetNumber) {
                clearTimeout(this.isNeedFillSteetNumber)
            }
            this.isNeedFillSteetNumber = setTimeout(() => {
                this.setState({
                    isNeedFillSteetNumber: false,
                })
            }, 6000)
        })
    }

    confirmDelivery = () => {
        if (!this.state.streetNumber) {
            this.showFillStreetNumberHint()
            return
        }

        //07-Apr: Remove confirm msg
        OrderHandler.setTableSessionType(TableSessionType.DELIVERY)
        OrderHandler.setDeliveryDistanceData(this.state.distanceData)
        OrderHandler.setDeliveryAddressComponents(this.getAddressComponents())
        OrderHandler.setDeliveryStreetNumber(this.state.streetNumber)
        OrderHandler.setDeliveryCoordinate(this.mapRef.current.getDestinationCoordinate())

        let deliveryDetail = new DeliveryDetail()
        deliveryDetail.lat = this.mapRef.current.getDestinationCoordinate().lat
        deliveryDetail.lng = this.mapRef.current.getDestinationCoordinate().lng
        deliveryDetail.addressComponents = this.getAddressComponents()
        deliveryDetail.deliveryCharge = this.state.distanceData.price
        deliveryDetail.distance = this.state.distanceData.distance
        deliveryDetail.duration = this.state.distanceData.duration
        deliveryDetail.streetNumber = this.state.streetNumber

        deliveryDetail.baseCharge = this.state.distanceData.basePrice
        deliveryDetail.processingFee = this.state.distanceData.processingFee
        deliveryDetail.merchantCoverFee = this.state.distanceData.merchantCoverFee

        OrderHandler.setDeliveryDetail(deliveryDetail)

        if (this.props.location.state && this.props.location.state.onConfirm) {
            this.props.history.push(this.props.location.state.onConfirm)
        }
        else {
            Navigator.goToCategory()
        }
    }

    getAddressComponents = () => {
        const {route, postalCode, administrativeAreaLevel_1, locality, sublocality} = this.state
        let addressComponents = [
            route,                          // Jalan
            sublocality,                    // Taman
            `${(postalCode && postalCode + " ") || ""}${locality || ""}`,    // Postcode + City
            administrativeAreaLevel_1,      // State
        ]
        addressComponents = addressComponents.filter(a => a).map((address, index, arr) => {
            if (index != arr.length - 1) {
                address += ","
            }
            return address
        })
        return addressComponents
    }

    render() {
        if (!this.props.app.state.table) {
            return <div></div>
        }

        let markers = [
            <OrderlahMarker key={1} position={{ lat: 2.994475, lng: 101.452353}} />,
        ]
        let addressComponents = this.getAddressComponents()
        const {price_text, duration_text, distance_text} = this.state.distanceData
        let back = `/${this.props.match.params.tableQR}`
        if (this.props.location.state && this.props.location.state.back) {
            back = this.props.location.state.selectLocationBack
        }

        let isButtonDisabled = !this.state.distanceData.distance || this.state.too_far
        const { isNeedFillSteetNumber, isShowHint, } = this.state
        let disabledStyle = {}
        if (isButtonDisabled) {
            disabledStyle = {
                opacity: 0.5
            }
        }

        return (
            <div>
                {this.state.confirmModal}
                <TopNav table={this.props.app.state.table}
                    title={lang.category}
                    orders={this.props.app.state.orders}
                    backLabel={lang.back} back={back} backButton={true}
                    pickup={this.props.app.state.table.pickup}
                    pin={this.props.app.state.current_session !== null && table_session_id !== null ? <button className="btn btn-primary btn-sm" onClick={this.showPinNumber}>{lang.show_pin}</button> : ''}
                    session={this.props.app.state.current_session}
                    tableQR={this.props.match.params.tableQR}
                />
                {
                    (true || this.state.initialPosition) &&
                    <div className="container body-content" style={{paddingTop: "60px", paddingLeft: "0px", paddingRight: "0px", paddingBottom: "10px",height: "calc(100vh - 55px)", width: "100vw", boxSizing: "border-box", display:"flex", flexDirection: "column"}}>
                        <div style={{display:"flex", padding: "0px 6px"}} className="mb-1 mt-1">
                            <div style={{flex: "1 0 100px"}} className="mr-1">
                                <LocationSearchInput onAutoCompletePlaceSelected={this.onAutoCompletePlaceSelected} currentCoordinate={this.state.currentLocation} />
                                <div>
                                    {
                                        isShowHint &&
                                        <span className="text-danger opacity-hint-animate animate">1. {lang.search_for_you_address_here}</span>
                                    }
                                    <img style={{ float: "right" }} src="/image/powered_by_google_on_white.png"/>
                                </div>
                            </div>
                            <div className="mr-1">
                                <button className="btn btn-default" onClick={this.zoomToDestination}><i className="fa fa-location-arrow" aria-hidden="true"></i></button>
                            </div>
                            {/* <div className="mr-1">
                                <button className="btn btn-default" onClick={this.setPinToMapClicked}><i className="fa fa-map-marker" aria-hidden="true"></i></button>
                            </div> */}
                            {
                                this.state.isShowGoToCurrentLocationButton &&
                                <>
                                    <div>
                                        <button className="btn btn-default" onClick={this.setPinToCurrentLocationClicked}><i className="fa fa-map-marker" aria-hidden="true"></i></button>
                                    </div>
                                </>
                            }
                            <div style={{textAlign: "right"}}>
                                <button className="btn btn-default" onClick={this.destinationMarkerChangeIcon}><i className="fa fa-question-circle" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div style={{display:"flex", flex: "1 0 50px"}} className="mt-2">
                            <div style={{padding: "0px 8px 8px 8px", flex: "2 0 100px"}}>
                                <div style={{padding: "0px 8px"}}>
                                    <strong>{lang.deliver_to || "Deliver to:"}</strong>
                                </div>
                                <input type="text" className={`form-control ${isNeedFillSteetNumber && "border-warning-animate animate"}`} placeholder={lang.street_number_placeholder} value={this.state.streetNumber} onChange={(e) => this.setState({streetNumber: e.target.value})  }/>
                                {
                                    isNeedFillSteetNumber &&
                                    <div className="text-danger opacity-animate animate">{this.getFillInStreetNumberHint()}</div>
                                }
                                <div style={{padding: "0px 8px"}}>
                                    {
                                        addressComponents.map((component, index) => {
                                            if (component) {
                                                return <div key={index}>
                                                    {component}
                                                </div>
                                            }
                                        })
                                    }
                                </div>
                            </div>
                            <div style={{display:"flex", flex: "1 0 100px", flexDirection:"column", justifyContent:"space-evenly", textAlign:"center"}}>
                                <DeliveryInfo label={lang.distance} value={distance_text} />
                                <DeliveryInfo label={lang.delivery_charge} value={price_text} description={this.state.too_far? "" : this.state.free_delivery? lang.tnc_applied : lang.estimated}/>
                                {/* <DeliveryInfo label={lang.time} value={duration_text} /> */}
                            </div>
                        </div>
                        <div style={{position: "relative", padding: "0px", width: "100%", flex: "3 0 50px"}}>
                            {
                                this.getMerchantCoordinate() &&
                                <MapContainer
                                    ref={this.mapRef}
                                    initialCenter={this.getMerchantCoordinate()}

                                    // This is one time setup, further state change will not be
                                    // captured. To change, call setDestinationPosition()
                                    destinationMarker={this.state.destinationMarker}
                                    geocodeResult={this.onGeocodeResult}
                                    mapReady={this.mapReady}
                                    markers={markers} />
                            }
                        </div>
                    </div>
                }
                <div style={{textAlign:"center", position:"fixed", width: "100%", bottom: "3px"}}>
                    <button id="select-delivery-location-confirm-address" className="mainpg-btn" style={{...disabledStyle, width: "95%", padding:"5px"}} onClick={this.confirmDelivery} disabled={isButtonDisabled}>
                        <span style={{ fontSize: "18px" }}>{lang.confirm}</span>
                    </button>
                </div>
            </div>
        );
    }
}

class LocationSearchInput extends React.Component {
    constructor(props) {
      super(props);
      this.state = { address: '' };
    }

    handleChange = address => {
      this.setState({ address });
    };

    handleSelect = (address, placeId) => {
        let geoCodePromise = null
        if (placeId) {
            geoCodePromise = geocodeByPlaceId(placeId)
        }
        else {
            geoCodePromise = geocodeByAddress(address)
        }

        geoCodePromise
        .then(results => {
            return new Promise(resolve => {
                getLatLng(results[0])
                .then(latLng => {
                    resolve([latLng, results])
                })
            })
        })
        .then(latLngAndResult => {
            this.props.onAutoCompletePlaceSelected(latLngAndResult[0], latLngAndResult[1])
        })
        .catch(error => console.error('Error', error));
    };

    getSearchOptions = () => {
        // Restrict result set to Malaysia
        let searchOptions = {
            componentRestrictions: {
                country: 'my'
            }
        }
        if (this.props.currentCoordinate) {
            const coor = this.props.currentCoordinate
            // and up to 5km within current location
            searchOptions = {
                ...searchOptions,
                location: new google.maps.LatLng(coor.lat, coor.lng),
                radius: 5000,
            }
        }
        return searchOptions
    }

    render() {
        return (
            <PlacesAutocomplete
            value={this.state.address}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
            searchOptions={this.getSearchOptions()}
            shouldFetchSuggestions={this.state.address.length > 2}
            >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div>
                <input
                    {...getInputProps({
                    placeholder: lang.search_place,
                    className: 'location-search-input form-control border-hint-animate animate',
                    })}
                />
                        <div className="autocomplete-dropdown-container" style={{position:"absolute", width: "100%", backgroundColor: "green", zIndex: "1000"}}>
                            {loading && <div>{lang.loading + "..."}</div>}
                            {suggestions.map(suggestion => {
                            const className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                            // inline style for demonstration purpose
                            const style = suggestion.active
                                ? { backgroundColor: '#fafafa', cursor: 'pointer', fontSize: "13pt", paddingBottom: "5px", paddingTop: "5px", }
                                : { backgroundColor: '#ffffff', cursor: 'pointer', fontSize: "13pt", paddingBottom: "5px", paddingTop: "5px", };
                            return (
                                <div
                                {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                })}
                                >
                                {/* <span>{suggestion.description}</span> */}
                                    <strong>
                                        {suggestion.formattedSuggestion.mainText}
                                    </strong>{' '}
                                    <small>
                                        {suggestion.formattedSuggestion.secondaryText}
                                    </small>
                                </div>
                            );
                            })}
                                {loading && <div style={{ backgroundColor: '#fafafa', float: 'right', paddingBottom: "5px", paddingTop: "5px" }}> HELLO </div>}
                        </div>
                </div>
            )}
            </PlacesAutocomplete>
        );
    }
}


function OrderlahMarker(props) {
    return (
        <div style={{backgroundColor: "red", width:"50px", height:"50px"}}>
            <img src="/images/map/orderlah-marker.png" className="orderlah-marker" />
            Hello Good Day
        </div>
    );
};

SelectDeliveryLocation.propTypes = {

};

export default SelectDeliveryLocation;